namespace RedBullMOBILE360.CVM {
    export namespace SegmentCriteriaService {
        export const baseUrl = 'CVM/SegmentCriteria';

        export declare function Create(request: Serenity.SaveRequest<SegmentCriteriaRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SegmentCriteriaRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SegmentCriteriaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SegmentCriteriaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "CVM/SegmentCriteria/Create",
            Update = "CVM/SegmentCriteria/Update",
            Delete = "CVM/SegmentCriteria/Delete",
            Retrieve = "CVM/SegmentCriteria/Retrieve",
            List = "CVM/SegmentCriteria/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SegmentCriteriaService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
